import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { theme } from "../../theme/theme";

function TableComponent({ sortable, tableData, columns, checked,checkboxDisabled, ...rest }) {
  return (
    <DataTable enableStickyHeader value={tableData} {...rest}>
      {checked && !checkboxDisabled ? (
        <Column
          headerClassName="stickyHeader"
          style={{ fontSize: "12px", padding: "5px" }}
          headerStyle={{
            padding: "5px",
            fontSize: "12px",
            backgroundColor: theme.colors.primary,
            color: "#fff",
          }}
          selectionMode="multiple"
          onse
        ></Column>
      ) : null}
      {columns.map((val, index) => {
        return (
          <Column
            headerClassName="stickyHeader"
            {...val}
            key={val.header + index}
            style={{ ...val.style, fontSize: "12px", padding: "5px" }}
            headerStyle={{
              padding: "5px",
              fontSize: "12px",
              backgroundColor: theme.colors.primary,
              color: "#fff",
              ...val.headerStyle,
            }}
          ></Column>
        );
      })}
    </DataTable>
  );
}

export default TableComponent;
